import React from 'react';
import { motion } from 'framer-motion';
import { FiInstagram, FiFacebook, FiArrowRight } from 'react-icons/fi';
import { SiTiktok } from 'react-icons/si';
import { siteData } from '../../data/content';

const platforms = [
  {
    label: 'Facebook',
    icon: FiFacebook,
    key: 'facebook',
    handle: '@AREliteDetailing',
    desc: 'Reviews & updates',
  },
  {
    label: 'Instagram',
    icon: FiInstagram,
    key: 'instagram',
    handle: '@a.r.elite_detailing',
    desc: 'Before & afters',
  },
  {
    label: 'TikTok',
    icon: SiTiktok,
    key: 'tiktok',
    handle: '@arelitedetailing',
    desc: 'Detail transformations',
  },
];

export default function SocialStrip() {
  return (
    <section className="py-16 bg-slate-900 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center gap-10">
          {/* Left label */}
          <div className="flex-shrink-0 text-center md:text-left">
            <span className="text-blue-500 font-bold tracking-widest uppercase text-xs block mb-1">
              Stay Connected
            </span>
            <h3 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight">
              See More of Our Work
            </h3>
            <p className="text-slate-400 text-sm mt-1 max-w-xs">
              Follow us for recent details, transformations & updates.
            </p>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-16 bg-slate-800 flex-shrink-0" />

          {/* Platform cards */}
          <div className="flex flex-col sm:flex-row gap-3 flex-grow w-full md:w-auto">
            {platforms.map(({ label, icon: Icon, key, handle, desc }, i) => (
              <motion.a
                key={key}
                href={siteData.business.socials[key]}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.07 }}
                className="group flex items-center gap-4 flex-1 bg-slate-950 border border-slate-800 px-5 py-4 rounded-sm hover:border-blue-500/50 hover:bg-slate-900 transition-all duration-200"
              >
                <div className="w-10 h-10 bg-blue-600/10 border border-blue-500/20 rounded-sm flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600/20 transition-colors">
                  <Icon className="text-blue-500 text-lg" />
                </div>
                <div className="flex-grow min-w-0">
                  <p className="text-white font-bold text-sm uppercase tracking-wide">{label}</p>
                  <p className="text-slate-500 text-xs truncate">{handle}</p>
                  <p className="text-slate-600 text-xs">{desc}</p>
                </div>
                <FiArrowRight className="text-slate-700 group-hover:text-blue-500 transition-colors flex-shrink-0" />
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}